export default "__VITE_ASSET__BkEffBHc__"